export default __webpack_public_path__ + "static/media/bgi.af18dde2.jpg";